import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-gap: 4rem;

	transform: translateY(50px);
 	opacity: 0;	
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 1.4s;
	margin-bottom: 16rem;

	h2 {
		grid-row: 1;
		grid-column: 5 / span 4;
		font-size: 6rem;
	}

	p {
		grid-row: 2;
		grid-column: 5 / -5;
		font-family: 'Karla';
		letter-spacing: 0;
		font-size: 1.8rem;
		line-height: 1.5em;
	}
	
	@media(max-width: 1230px) {
		grid-column-gap: 0rem;
		p, h2 {
			grid-column: 2 / -2;
		}
		p {
			column-count: 2;
		}
	}

	@media(max-width: 900px) {
		p {
			font-size: 1.6rem;
			column-count: 1;
		}
	}
`


const About = ({data}) => (
	<AboutSection>
		<h2>{data.title}</h2>
		<p>{data.text}</p>
	</AboutSection>
)

export default About;



// WEBPACK FOOTER //
// ./src/compontents/about.js